import { __extends } from "tslib";
import { PutObjectTaggingOutput, PutObjectTaggingRequest } from "../models/models_0";
import { deserializeAws_restXmlPutObjectTaggingCommand, serializeAws_restXmlPutObjectTaggingCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutObjectTaggingCommand = /** @class */ (function (_super) {
    __extends(PutObjectTaggingCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutObjectTaggingCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutObjectTaggingCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutObjectTaggingCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: PutObjectTaggingRequest.filterSensitiveLog,
            outputFilterSensitiveLog: PutObjectTaggingOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutObjectTaggingCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutObjectTaggingCommand(input, context);
    };
    PutObjectTaggingCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutObjectTaggingCommand(output, context);
    };
    return PutObjectTaggingCommand;
}($Command));
export { PutObjectTaggingCommand };
//# sourceMappingURL=PutObjectTaggingCommand.js.map